import { render, staticRenderFns } from "./CapturaDocumentosGaleria.vue?vue&type=template&id=aebdd0f4&scoped=true&"
import script from "./CapturaDocumentosGaleria.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentosGaleria.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentosGaleria.vue?vue&type=style&index=0&id=aebdd0f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebdd0f4",
  null
  
)

export default component.exports